"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const langCode = document.getElementById("lang-code");
let code;
if (langCode) {
    code = langCode.dataset.code;
}
else {
    console.warn("No lang-code element, defaulting to 'en'");
    code = "en";
}
exports.default = {
    de: {
        not: "Nicht",
        exact: "Exakt",
        range: "Zeitraum",
        yearPlaceholder: "JJJJ",
        monthPlaceholder: "M",
        dayPlaceholder: "T",
        submit: "Absenden",
        code: "de",
        to: "bis",
        viewOrcId: "ORCID Profil ansehen",
        viewAuthorBio: "Autorenbiographie ansehen",
        emailAuthor: "E-mail Autor/in",
        searchForAuthorIn: "Diesen Autor / diese Autorin suchen:",
        googleScholar: "Google Scholar",
        searching: "Suchen..."
    },
    en: {
        not: "Not",
        exact: "Exact",
        range: "Range",
        yearPlaceholder: "YYYY",
        monthPlaceholder: "M",
        dayPlaceholder: "D",
        submit: "Submit",
        code: "en",
        to: "to",
        viewOrcId: "View ORCID profile",
        viewAuthorBio: "View author bio",
        emailAuthor: "Email author",
        searchForAuthorIn: "Search for this author in:",
        googleScholar: "Google Scholar",
        searching: "Searching..."
    },
}[code];
